import { setElementVisibility } from '../util/visibility';
import { AppId } from '../enums/elementId';
import {
    OFFER_PIRCE_BUTTON,
    ARROW_ICON_BOTTOM,
    ARROW_ICON_FLOATING_BTN_BOTTOM,
    ARROW_ICON_HREF,
    HELP_ICON_DRAWER,
    HELP_ICON_FLOATING_BTN_PADDING_BOTTOM,
    HELP_ICON_PADDING_BOTTOM,
    HELP_ICON_TRIGGER,
} from '../constants';
import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';

/**
 *
 */
export const resetIconsPosition = () => {
    const drawer = document.querySelector(HELP_ICON_DRAWER) as HTMLElement | null;

    const trigger =
        drawer && (drawer.querySelector(HELP_ICON_TRIGGER) as HTMLElement | null);

    const anchorTopDiv = document.querySelector(ARROW_ICON_HREF) as HTMLElement | null;
    const floatingButtonIsShown = (document.getElementById(AppId.FLOATING_NOTIFICATION) as HTMLElement)
        .classList
        .contains(CLASSNAME_HIDDEN);

    if (trigger) {
        drawer.style.bottom = !floatingButtonIsShown ? HELP_ICON_FLOATING_BTN_PADDING_BOTTOM : HELP_ICON_PADDING_BOTTOM;
    }

    if (anchorTopDiv) {
        anchorTopDiv.style.bottom = !floatingButtonIsShown ? ARROW_ICON_FLOATING_BTN_BOTTOM : ARROW_ICON_BOTTOM;
    }
};

/**
 * handleButtonVisibility
 * Function to toggle the floating button visibility based on scroll direction and window width
 */
export const handleButtonVisibility = () => {
    const offerPriceButton = document.querySelector(
        OFFER_PIRCE_BUTTON,
    ) as HTMLElement | null;

    const drawer = document.querySelector(HELP_ICON_DRAWER) as HTMLElement | null;

    const trigger =
        drawer && (drawer.querySelector(HELP_ICON_TRIGGER) as HTMLElement | null);

    const anchorTopDiv = document.querySelector(ARROW_ICON_HREF) as HTMLElement | null;

    const hideButton =
        window.innerWidth >= 1024 ||
        !(offerPriceButton!.getBoundingClientRect().top < 10);

    setElementVisibility(AppId.FLOATING_NOTIFICATION, !hideButton);

    if (trigger) {
        drawer.style.bottom = !hideButton ? HELP_ICON_FLOATING_BTN_PADDING_BOTTOM : HELP_ICON_PADDING_BOTTOM;
    }

    if (anchorTopDiv) {
        anchorTopDiv.style.bottom = !hideButton ? ARROW_ICON_FLOATING_BTN_BOTTOM : ARROW_ICON_BOTTOM;
    }
};

/**
 * updateFloatingMobileNotification
 * fn to update the floating mobile notification in scroll and resizing screen
 *
 * @param {boolean} show -show floating button
 */
export const updateFloatingMobileNotification = (show?: boolean) => {
    if (show) {
        setTimeout(() => {
            handleButtonVisibility();
        }, 100);

        window.addEventListener('scroll', handleButtonVisibility);

        window.addEventListener('resize', handleButtonVisibility);

        return;
    }

    window.removeEventListener('scroll', handleButtonVisibility);

    window.removeEventListener('resize', handleButtonVisibility);

    setElementVisibility(AppId.FLOATING_NOTIFICATION, false);
};
